import { mount } from "svelte";

export function renderComponent(Component, props = {}, targetId = "modal-root") {
  if (!document.getElementById(targetId)) {
    const modalRoot = document.createElement("div");
    modalRoot.id = targetId;
    document.body.appendChild(modalRoot);
  }
  const target = document.getElementById(targetId);

  // 创建一个容器
  const container = document.createElement("div");
  target.appendChild(container);

  // 用 mount 挂载组件
  mount(Component, {
    target: container,
    props,
  });

  // 提供销毁方法
  return {
    destroyWithRemove() {
      container.remove();
    },
  };
}
